import { iconSwitchTransition as i } from "./ghl-ui.es1318.js";
import { cB as o, cE as t, c as e, cM as r, cNotM as n } from "./ghl-ui.es384.js";
const s = o("switch", `
 height: var(--n-height);
 min-width: var(--n-width);
 vertical-align: middle;
 user-select: none;
 -webkit-user-select: none;
 display: inline-flex;
 outline: none;
 justify-content: center;
 align-items: center;
`, [t("children-placeholder", `
 height: var(--n-rail-height);
 display: flex;
 flex-direction: column;
 overflow: hidden;
 pointer-events: none;
 visibility: hidden;
 `), t("rail-placeholder", `
 display: flex;
 flex-wrap: none;
 `), t("button-placeholder", `
 width: calc(1.75 * var(--n-rail-height));
 height: var(--n-rail-height);
 `), o("base-loading", `
 position: absolute;
 top: 50%;
 left: 50%;
 transform: translateX(-50%) translateY(-50%);
 font-size: calc(var(--n-button-width) - 4px);
 color: var(--n-loading-color);
 transition: color .3s var(--n-bezier);
 `, [i({
  left: "50%",
  top: "50%",
  originalTransform: "translateX(-50%) translateY(-50%)"
})]), t("checked, unchecked", `
 transition: color .3s var(--n-bezier);
 color: var(--n-text-color);
 box-sizing: border-box;
 position: absolute;
 white-space: nowrap;
 top: 0;
 bottom: 0;
 display: flex;
 align-items: center;
 line-height: 1;
 `), t("checked", `
 right: 0;
 padding-right: calc(1.25 * var(--n-rail-height) - var(--n-offset));
 `), t("unchecked", `
 left: 0;
 justify-content: flex-end;
 padding-left: calc(1.25 * var(--n-rail-height) - var(--n-offset));
 `), e("&:focus", [t("rail", `
 box-shadow: var(--n-box-shadow-focus);
 `)]), r("round", [t("rail", "border-radius: calc(var(--n-rail-height) / 2);", [t("button", "border-radius: calc(var(--n-button-height) / 2);")])]), n("disabled", [n("icon", [r("rubber-band", [r("pressed", [t("rail", [t("button", "max-width: var(--n-button-width-pressed);")])]), t("rail", [e("&:active", [t("button", "max-width: var(--n-button-width-pressed);")])]), r("active", [r("pressed", [t("rail", [t("button", "left: calc(100% - var(--n-offset) - var(--n-button-width-pressed));")])]), t("rail", [e("&:active", [t("button", "left: calc(100% - var(--n-offset) - var(--n-button-width-pressed));")])])])])])]), r("active", [t("rail", [t("button", "left: calc(100% - var(--n-button-width) - var(--n-offset))")])]), t("rail", `
 overflow: hidden;
 height: var(--n-rail-height);
 min-width: var(--n-rail-width);
 border-radius: var(--n-rail-border-radius);
 cursor: pointer;
 position: relative;
 transition:
 opacity .3s var(--n-bezier),
 background .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
 background-color: var(--n-rail-color);
 `, [t("button-icon", `
 color: var(--n-icon-color);
 transition: color .3s var(--n-bezier);
 font-size: calc(var(--n-button-height) - 4px);
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 display: flex;
 justify-content: center;
 align-items: center;
 line-height: 1;
 `, [i()]), t("button", `
 align-items: center; 
 top: var(--n-offset);
 left: var(--n-offset);
 height: var(--n-button-height);
 width: var(--n-button-width-pressed);
 max-width: var(--n-button-width);
 border-radius: var(--n-button-border-radius);
 background-color: var(--n-button-color);
 box-shadow: var(--n-button-box-shadow);
 box-sizing: border-box;
 cursor: inherit;
 content: "";
 position: absolute;
 transition:
 background-color .3s var(--n-bezier),
 left .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 max-width .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
 `)]), r("active", [t("rail", "background-color: var(--n-rail-color-active);")]), r("loading", [t("rail", `
 cursor: wait;
 `)]), r("disabled", [t("rail", `
 cursor: not-allowed;
 opacity: .5;
 `)])]);
export {
  s as default
};
